import * as React from "react";
const SvgClear = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L12 12M1 12L12 1", stroke: "#4F2714", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgClear;
